import React from "react";
import { Controller } from "react-hook-form";
import type { Control } from "react-hook-form";
import { z } from "zod";
import { useTranslation } from "react-i18next";
import InputField from "@components/common/InputField";
import { createLabSchema } from "../../../schema";

type LabFormData = z.infer<typeof createLabSchema>;

interface LabDescriptionFieldProps {
	control: Control<LabFormData>;
	isSubmitting: boolean;
}

const LabDescriptionField: React.FC<LabDescriptionFieldProps> = ({ control, isSubmitting }) => {
	const { t } = useTranslation();

	return (
		<Controller
			name="description"
			control={control}
			render={({ field, fieldState }) => (
				<InputField
					id="lab-description"
					label={t("feature.courseBuilder.labs.createLab.description")}
					type="text"
					placeholder={t("feature.courseBuilder.labs.createLab.enterDescription")}
					multiline
					rows={4}
					error={!!fieldState.error}
					helperText={fieldState.error?.message}
					disabled={isSubmitting}
					{...field}
					value={field.value || ""}
				/>
			)}
		/>
	);
};

export default LabDescriptionField;
